import React from "react";
import BaseComponentInternas from "../../Components/BaseComponentInternas";
import FinanceiroComponent from "../../Components/Financeiro";

const PageFinanceiro = (props) => {
  return (
    <BaseComponentInternas>
      <FinanceiroComponent
        idVenda={props.location.state?.idVenda ?? null}
        redirectRenegociar={props.location.state?.redirectRenegociar}
      />
    </BaseComponentInternas>
  );
};

export default PageFinanceiro;
